/* eslint-disable @typescript-eslint/restrict-plus-operands */
/* eslint-disable security/detect-object-injection */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */
import React, { useState, useRef, useEffect } from 'react';
import { FaVolumeMute, FaVolumeUp } from 'react-icons/fa';
import { ReactReader } from 'react-reader';
import { IMoeEpubViewerViewProps } from './moe-epub-viewer';
import { BiFirstPage, BiLastPage } from 'react-icons/bi';

export default (props: IMoeEpubViewerViewProps) => {
    // Variables declarations
    let audioParaNumber = 0;
    let smlObjIndex = 0;
    let firstPageEpubCifi: any;
    let currentPageEpubCifi: any;
    let totalNumberOfPages: any;

    // And your own state logic to persist state
    console.log(props);
    const { config } = props;
    const [location, setLocation] = useState<any>(null);
    const [smlObj, setSmlObj] = useState<any>([]);
    const [isAudioEnabled, setIsAudioEnabled] = useState(false);
    const [isAutoTurnEnabled, setIsAutoTurnEnabled] = useState(false);
    const [pageNumbersText, setPageNumbersText] = useState('');
    const [bigFileNotification, setBigFileNotification] = useState('');
    const [isNavControlsEnabled, setIsNavControlsEnabled] = useState(false);
    const [isAudioBtnEnabled, setIsAudioBtnEnabled] = useState(false);
    const [epubTitle, setEpubTitle] = useState('');
    // Ref to keep the book on track
    const renditionRef: any = useRef(null);
    const tocRef = useRef(null);

    // Effects to keep the track state changes and execute based on data
    useEffect(() => {
        console.log('Effect state');
        if (isAudioEnabled === true) {
            audioParaNumber = 0;
            smlObjIndex = 0;
            playAudio();
        }
    }, [smlObj]);

    useEffect(() => {
        console.log('Use Effect execution');
        void locationChanged(currentPageEpubCifi);
    }, [renditionRef.current?.book]);

    // Effect to check if video files present in Ebook.
    // useEffect(() => {
    //     if (renditionRef?.current?.book?.package?.manifest) {
    //         const { manifest } = renditionRef.current.book.package;
    //         // eslint-disable-next-line guard-for-in
    //         for (const key in manifest) {
    //             const type = manifest[key].type.split('/');
    //             if (type[0] === 'video') {
    //                 setIsVideo(true);
    //             }
    //         }
    //     }
    // }, [renditionRef?.current?.book?.package]);
    /*
        Function Name: setPageNumbersTextfn
        functonality: Gives the text of which page you are currently in
     */
    const setPageNumbersTextfn = () => {
        if (
            renditionRef.current?.location?.start &&
            renditionRef?.current?.location?.end &&
            renditionRef.current?.location?.start.index >= 0 &&
            renditionRef?.current?.location?.end.index >= 0
        ) {
            if (renditionRef.current?.location?.start.index === renditionRef?.current?.location?.end.index) {
                setPageNumbersText(`${renditionRef.current?.location?.start.index + 1} of ${totalNumberOfPages}`);
            } else if (renditionRef.current?.location?.start.index !== renditionRef?.current?.location?.end.index) {
                setPageNumbersText(
                    `${renditionRef.current?.location?.start.index + 1}-${renditionRef.current?.location?.end.index +
                        1} of ${totalNumberOfPages}`
                );
            } else {
                setPageNumbersText('');
            }
        }
    };

    /*
        Function Name: locationChanged
        functonality: locationchanged is used to track the page change and fetch info based on data available from page
     */
    const locationChanged = async (_epubcifi: any) => {
        // Remove the audio player if we change the page.
        const body = document.getElementsByTagName('body')[0];
        const audioPlayer = document.getElementsByClassName('moe-epub-reader-audio-player')[0];
        if (audioPlayer) {
            body.removeChild(audioPlayer);
        }

        if (_epubcifi && firstPageEpubCifi === undefined) {
            firstPageEpubCifi = _epubcifi;
        }

        if (renditionRef.current?.book === undefined) {
            currentPageEpubCifi = _epubcifi;
            return;
        }

        audioParaNumber = 0;
        smlObjIndex = 0;

        // const previousPageName = smlObj[0]?.pageName || '';
        if (renditionRef.current && tocRef.current && renditionRef.current.location) {
            const { displayed, href } = renditionRef.current.location.start;
            const endHref = renditionRef.current.location.end.href;
            console.log('rendition ref', displayed, href, renditionRef.current, tocRef);

            if (renditionRef.current && renditionRef.current.book && renditionRef.current.book.packaging) {
                setEpubTitle(renditionRef.current.book.packaging.metadata.title || '');
            }

            if (renditionRef.current.book.spine && renditionRef.current.book.spine.length) {
                totalNumberOfPages = renditionRef.current.book.spine.length;
            } else {
                totalNumberOfPages = 'n/a';
            }

            setPageNumbersTextfn();

            const smlStartReplacementUrl = getSmilReplacementUrl(href);
            const startSmilObj = await getSmilAttributes(smlStartReplacementUrl);
            let endSmlObj: any = {};

            if (href !== endHref) {
                const smlEndReplacementUrl = getSmilReplacementUrl(endHref);
                endSmlObj = await getSmilAttributes(smlEndReplacementUrl);
            }

            setSmlObj([startSmilObj, endSmlObj]);
        }
        setLocation(_epubcifi);
        audioParaNumber = 0;
        smlObjIndex = 0;
        // if (isAudioEnabled) {
        //     const nextSlideAudioPlayInterval = setInterval(() => {
        //         if (previousPageName !== smlObj[0].pageName) {
        //             clearInterval(nextSlideAudioPlayInterval);
        //             playAudio();
        //         }
        //     }, 1000);
        // }

        if (isNavControlsEnabled === false || isAudioBtnEnabled === false) {
            setTimeout(() => {
                if (isNavControlsEnabled === false) {
                    setIsNavControlsEnabled(true);
                }

                // check whether the Audio is available in the first place, Then enable the audio button
                if (isAudioBtnEnabled === false) {
                    if (
                        renditionRef.current &&
                        renditionRef.current.book &&
                        renditionRef.current.book.packaging &&
                        renditionRef.current.book.packaging.metadata.media_active_class
                    ) {
                        setIsAudioBtnEnabled(true);
                        return;
                    }

                    if (smlObj[0]) {
                        const firstAudioPoint = smlObj[0] && smlObj[0].paragraphs && smlObj[0].paragraphs[0]?.clipBegin;
                        const secondAudioPoint = smlObj[0] && smlObj[0].paragraphs && smlObj[0]?.paragraphs[0]?.clipEnd;
                        const initialUrl = smlObj[0] && smlObj[0].paragraphs && smlObj[0]?.paragraphs[0]?.audioFilePathFinal;

                        if (firstAudioPoint && secondAudioPoint && initialUrl) {
                            setIsAudioBtnEnabled(true);
                        } else {
                            setIsAudioBtnEnabled(false);
                        }
                    }
                }
            }, 0);
        }

        // renditionRef.current.hooks.content.register((contents: any) => {
        //     contents.document.defaultView.location = {
        //         set href(href: any) {
        //             renditionRef.current.display(href);
        //         }
        //     };
        // });
    };

    /*
        Function Name: getSmilAttributes
        functonality: getSmilAttributes is used to fetch blob object from blob url
     */
    const getSmilAttributes: any = async (replacementUrl: any) => {
        if (!replacementUrl) {
            return {};
        }
        const finalObj = await fetch(replacementUrl)
            .then(res => {
                return res.blob();
            })
            .then(blob => {
                const obj = readFile(blob);
                return obj;
            })
            .catch(e => {
                console.log('Error occured', e);
            });
        console.log(finalObj, 'Obj');
        return finalObj;
    };

    /*
        Function Name: readFile
        functonality: readFile is used to read smil file using blob object
     */
    const readFile = (input: Blob) => {
        const fr = new FileReader();
        const smlObj = {
            pageName: ''
        };
        fr.readAsText(input);
        fr.addEventListener('load', () => {
            const res = fr.result;
            const client = new XMLHttpRequest();
            // @ts-ignore
            client.open('GET', res);
            client.onreadystatechange = function() {
                const parser = new DOMParser();
                const xmlDoc = parser.parseFromString(res as any, 'text/xml');
                const parTags = xmlDoc.getElementsByTagName('par');
                const parTagsArray = Array.from(parTags);
                parTagsArray.forEach((element: any) => {
                    const innerObj = {};
                    Array.from(element.children).forEach((childElm: any) => {
                        if (childElm.nodeName === 'text') {
                            const splitElm = childElm.attributes[0].value.split('#');
                            innerObj['textPageName'] = splitElm[0];
                            innerObj['textWordId'] = splitElm[1];
                        } else if (childElm.nodeName === 'audio') {
                            Array.from(childElm.attributes).forEach((audioElm: any) => {
                                if (audioElm.nodeName === 'src' && renditionRef.current?.book) {
                                    console.log(audioElm, 'audio elm', parTagsArray);

                                    const { urls, replacementUrls } = renditionRef.current?.book?.resources;
                                    const splitedAudioName = audioElm.value.split('/');
                                    const index = urls.findIndex((url: any) => url.includes(splitedAudioName[splitedAudioName.length - 1]));
                                    innerObj['audioFilePathFinal'] = replacementUrls[index];
                                } else {
                                    innerObj[audioElm.name] = audioElm.value;
                                }
                            });
                        }
                    });
                    smlObj.pageName = innerObj['textPageName'];
                    smlObj['paragraphs'] = smlObj['paragraphs']?.length ? [...smlObj['paragraphs'], innerObj] : [innerObj];
                });
            };
            client.send();
        });
        return smlObj;
    };

    /*
        Function Name: getSmilReplacementUrl
        functonality: getSmilReplacementUrl is used to fetch the replacement urls from resources
     */
    const getSmilReplacementUrl = (pageName: any) => {
        if (renditionRef.current) {
            // @ts-ignore
            const { book } = renditionRef.current;
            // @ts-ignore
            const { manifest } = book.package;
            let smilFileName = '';
            for (const key in manifest) {
                if (manifest[key].href === pageName && manifest[key].type === 'application/xhtml+xml') {
                    const smilFileId = manifest[key].overlay;
                    smilFileName = manifest[smilFileId]?.href || '';
                }
            }
            // @ts-ignore
            const { urls, replacementUrls } = book.resources;
            const index = urls.indexOf(smilFileName);
            return replacementUrls[index];
        }
    };

    /*
        Function Name: changeAudioPoints
        functonality: changeAudioPoints is used to play audio between two time points
     */
    const changeAudioPoints = (firstPoint: any, secondPoint: any, initialAudioUrl: any, highlighterWordsId: any) => {
        const body = document.getElementsByTagName('body')[0];
        const audioPlayer = document.createElement('audio');
        const epubIframe: any = document.querySelector('.epub-view iframe');
        let epubDom: any;
        let wordId: any;

        if (epubIframe) {
            epubDom = epubIframe.contentDocument || epubIframe.contentWindow.document;
            if (epubDom) {
                wordId = epubDom.getElementById(highlighterWordsId);
                if (wordId) {
                    // wordId.classList.add('moe-epub-sync');
                    wordId.style.color = 'red';
                }
            }
        }
        audioPlayer.className = 'moe-epub-reader-audio-player';
        audioPlayer.style.height = '0px';

        audioPlayer.src = `${initialAudioUrl}#t=${firstPoint},${secondPoint}`;
        body.appendChild(audioPlayer);

        setTimeout(() => {
            void audioPlayer.play().catch(e => {
                console.log('Error while playing the audio', e);
                audioParaNumber = 0;
                smlObjIndex = 0;
                setIsAudioEnabled(false);
            });
        }, 0);
    };

    /*
        Function Name: pauseEventTrigger
        functonality: pauseEventTrigger is used to execute the code when audio player pauses
     */
    const pauseEventTrigger = (highlighterWordsId = '') => {
        const epubIframe: any = document.querySelector('.epub-view iframe');
        let epubDom;
        let wordId;

        if (epubIframe) {
            epubDom = epubIframe.contentDocument || epubIframe.contentWindow.document;
            if (epubDom) {
                wordId = epubDom.getElementById(highlighterWordsId);
                // wordId.classList.remove('moe-epub-sync');
                if (wordId) {
                    wordId.style.color = 'black';
                }
            }
        }

        const audioPlayer = document.getElementsByClassName('moe-epub-reader-audio-player')[0];

        // If audio player exist, then delete it.
        if (!audioPlayer) {
            return;
        }

        setTimeout(() => {
            playAudio();
        }, 100);
    };

    /*
        Function Name: playAudio
        functonality: playAudio is used to execute core logic of playing audio inside epub
     */
    const playAudio = () => {
        let highlighterWordsId: any;
        const body = document.getElementsByTagName('body')[0];
        const eBook: any = document.getElementsByClassName('moe-ebook')[0];
        const eBookControls: any = document.getElementsByClassName('moe-ebook-controls')[0];
        if (eBook) {
            eBook.style.pointerEvents = 'none';
        }

        if (eBookControls) {
            eBookControls.style.pointerEvents = 'all';
        }
        let audioPlayer = document.getElementsByClassName('moe-epub-reader-audio-player')[0];
        if (audioPlayer) {
            body.removeChild(audioPlayer);
        }

        try {
            // If one page loaded then use this if condition
            if (
                audioParaNumber > smlObj[smlObjIndex]?.paragraphs.length - 1 &&
                (JSON.stringify(smlObj[1]) === '{}' || JSON.stringify(smlObj[1]) === undefined || smlObj[1].pageName === '')
            ) {
                const audioPlayer = document.getElementsByClassName('moe-epub-reader-audio-player')[0];
                if (audioPlayer) {
                    audioPlayer.removeEventListener('pause', () => pauseEventTrigger());
                    body.removeChild(audioPlayer);
                }
                setTimeout(() => {
                    if (eBook) {
                        eBook.style.pointerEvents = 'all';
                    }
                }, 1000);

                smlObjIndex = 0;
                audioParaNumber = 0;

                if (isAutoTurnEnabled) {
                    if (!renditionRef.current.location.atEnd) {
                        renditionRef.current.next();
                    } else {
                        setIsAutoTurnEnabled(false);
                    }
                }
                return;
            }

            // If two pages loaded, Then use this if condition
            if (
                audioParaNumber > smlObj[smlObjIndex]?.paragraphs.length - 1 &&
                (JSON.stringify(smlObj[1]) !== '{}' || JSON.stringify(smlObj[1]) !== undefined || smlObj[1].pageName === '')
            ) {
                const audioPlayer: any = document.getElementsByClassName('moe-epub-reader-audio-player')[0];
                if (audioPlayer) {
                    audioPlayer.removeEventListener('pause', pauseEventTrigger);
                    body.removeChild(audioPlayer);
                }

                if (smlObjIndex === 0) {
                    audioParaNumber = 0;
                    smlObjIndex = smlObjIndex + 1;
                } else if (smlObjIndex === 1) {
                    if (eBook) {
                        // @ts-ignore
                        eBook.style.pointerEvents = 'all';
                    }

                    smlObjIndex = 0;
                    audioParaNumber = 0;

                    if (isAutoTurnEnabled) {
                        if (!renditionRef.current.location.atEnd) {
                            renditionRef.current.next();
                        } else {
                            setIsAutoTurnEnabled(false);
                        }
                    }
                    return;
                }
            }

            if (smlObj[smlObjIndex]?.paragraphs) {
                // Audio points that needs to be shared with ebook audio play.
                const firstAudioPoint = smlObj[smlObjIndex]?.paragraphs[audioParaNumber].clipBegin;
                const secondAudioPoint = smlObj[smlObjIndex]?.paragraphs[audioParaNumber].clipEnd;
                const initialUrl = smlObj[smlObjIndex]?.paragraphs[audioParaNumber].audioFilePathFinal;
                highlighterWordsId = smlObj[smlObjIndex]?.paragraphs[audioParaNumber].textWordId;

                // setAudioParaNumber((prev) => prev + 1);
                audioParaNumber = audioParaNumber + 1;
                changeAudioPoints(firstAudioPoint, secondAudioPoint, initialUrl, highlighterWordsId);

                audioPlayer = document.getElementsByClassName('moe-epub-reader-audio-player')[0];

                if (audioPlayer && firstAudioPoint && secondAudioPoint && initialUrl) {
                    audioPlayer.addEventListener('pause', () => pauseEventTrigger(highlighterWordsId));
                } else {
                    if (eBook) {
                        eBook.style.pointerEvents = 'all';
                    }
                }
            } else {
                if (eBook) {
                    eBook.style.pointerEvents = 'all';
                }
            }
        } catch (e) {
            console.log('Error in audio playing, Trying to play audio after 1 second.', e);
            setTimeout(() => {
                playAudio();
            }, 1000);
            eBook.style.pointerEvents = 'all';
        }
    };

    /*
        Function Name: enableAudio
        functonality: enableAudio is used to toggle between audio enabling and disabling
     */
    const enableAudio = () => {
        if (!isAudioEnabled === false) {
            // pauseEventAudioPlay = false;

            // Fetch required DOM Elements
            const body = document.getElementsByTagName('body')[0];
            const eBook: any = document.getElementsByClassName('moe-ebook')[0];
            const audioPlayer = document.getElementsByClassName('moe-epub-reader-audio-player')[0];

            // If audio player exist, then delete it.
            if (audioPlayer) {
                body.removeChild(audioPlayer);
            }
            setIsAudioEnabled(prev => !prev);
            if (eBook) {
                eBook.style.pointerEvents = 'all';
            }
            audioParaNumber = 0;
            smlObjIndex = 0;
            return;
        } else {
            setIsAudioEnabled(prev => !prev);
            // pauseEventAudioPlay = true;
            playAudio();
        }
    };

    /*
        Function Name: getFirstPage
        functonality: getFirstPage is used to redirect the epub to first page
     */
    const getFirstPage = () => {
        const body = document.getElementsByTagName('body')[0];
        const eBook: any = document.getElementsByClassName('moe-ebook')[0];
        const audioPlayer = document.getElementsByClassName('moe-epub-reader-audio-player')[0];

        if (eBook) {
            eBook.style.pointerEvents = 'all';
        }

        if (audioPlayer) {
            body.removeChild(audioPlayer);
        }
        setIsAudioEnabled(false);
        setLocation(firstPageEpubCifi);
        void locationChanged(firstPageEpubCifi);
        // renditionRef.current.book.spine.first();
    };

    /*
        Function Name: getLastPage
        functonality: getLastPage is used to redirect the epub to last page
     */
    const getLastPage = () => {
        const body = document.getElementsByTagName('body')[0];
        const audioPlayer = document.getElementsByClassName('moe-epub-reader-audio-player')[0];
        if (audioPlayer) {
            body.removeChild(audioPlayer);
        }
        setLocation(renditionRef.current.book.spine.length - 1);
    };

    /*
        Function Name: enableAutoTurn
        functonality: enableAutoTurn is used to turn the pages when the epub is of audio resource
     */
    const enableAutoTurn = () => {
        setIsAutoTurnEnabled(prev => !prev);
        if (isAudioEnabled === true) {
            // pauseEventAudioPlay = false;

            // Fetch required DOM Elements
            const body = document.getElementsByTagName('body')[0];
            const eBook: any = document.getElementsByClassName('moe-ebook')[0];
            const audioPlayer = document.getElementsByClassName('moe-epub-reader-audio-player')[0];

            // If audio player exist, then delete it.
            if (audioPlayer) {
                body.removeChild(audioPlayer);
            }
            setIsAudioEnabled(prev => !prev);
            if (eBook) {
                eBook.style.pointerEvents = 'all';
            }
            audioParaNumber = 0;
            smlObjIndex = 0;
            return;
        }
    };

    setTimeout(() => {
        setBigFileNotification('Please hold on for a moment, the epub file is taking longer than usual to load...');
    }, 60000);

    // const ownStyles = {
    //     arrow: {
    //         color: 'red'
    //     }
    // };

    return (
        <>
            <div tabIndex={0} className='moe-ebook'>
                {isNavControlsEnabled && (
                    <div className='moe-ebook-controls'>
                        <div className='epub-nav-controls epub-autoturn-cont'>
                            <label className='epub-autoturn-label'>
                                <input
                                    disabled={isAudioBtnEnabled ? false : true}
                                    onChange={enableAutoTurn}
                                    type='checkbox'
                                    name='page-turn'
                                    id='page-turn'
                                ></input>
                                <span>Auto page-turn</span>
                            </label>
                        </div>
                        <div className='epub-nav-controls epub-startend-cont'>
                            <button
                                type='button'
                                className={
                                    renditionRef.current?.location?.atStart
                                        ? 'epub-startend-btn epub-startend-btn--inactive'
                                        : 'epub-startend-btn'
                                }
                                onClick={getFirstPage}
                                disabled={isNavControlsEnabled ? false : true}
                            >
                                <BiFirstPage /> Start
                            </button>
                            <p className='epub-page-count'>{pageNumbersText}</p>
                            <button
                                type='button'
                                className={
                                    renditionRef.current?.location?.atEnd
                                        ? 'epub-startend-btn epub-startend-btn--inactive'
                                        : 'epub-startend-btn'
                                }
                                onClick={getLastPage}
                                disabled={isNavControlsEnabled ? false : true}
                            >
                                End <BiLastPage />
                            </button>
                        </div>
                        <div className='epub-nav-controls epub-readaloud-cont'>
                            {/* <div>
                                <button type='button' onClick={muteAudio}>
                                    Mute <FaVolumeOff />
                                </button>
                            </div> */}
                            <div>
                                <button
                                    type='button'
                                    className={isAudioEnabled ? 'epub-read-loud-btn epub-read-loud-btn--active' : 'epub-read-loud-btn'}
                                    onClick={enableAudio}
                                    disabled={isAudioBtnEnabled ? false : true}
                                >
                                    Read Aloud {isAudioEnabled ? <FaVolumeUp /> : <FaVolumeMute />}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
                <ReactReader
                    locationChanged={locationChanged}
                    url={config.epubUrl || ''}
                    getRendition={(rendition: any) => (renditionRef.current = rendition)}
                    tocChanged={(toc: any) => {
                        tocRef.current = toc;
                        console.log('toc', toc);
                    }}
                    location={location}
                    title={config.title || epubTitle}
                    epubInitOptions={{
                        openAs: 'epub'
                    }}
                    epubOptions={{
                        allowScriptedContent: true,
                        infinite: true,
                        resizeOnOrientationChange: true
                    }}
                    loadingView={
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                height: '100%'
                            }}
                        >
                            <div className='lds-roller'>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <p>{bigFileNotification}</p>
                        </div>
                    }
                />

                {/* {smlObj[0] && (
                    <div className='moe-ebook-controls--mobile'>
                        <div className='epub-nav-controls epub-autoturn-cont'>
                            <label className='epub-autoturn-label'>
                                <input
                                    disabled={isAudioBtnEnabled ? false : true}
                                    onChange={enableAutoTurn}
                                    type='checkbox'
                                    name='page-turn'
                                    id='page-turn'
                                ></input>
                                <span>Auto page-turn</span>
                            </label>
                        </div>
                        <div className='epub-nav-controls epub-startend-cont'>
                            <button
                                type='button'
                                className={
                                    renditionRef.current?.location?.atStart
                                        ? 'epub-startend-btn epub-startend-btn--inactive'
                                        : 'epub-startend-btn'
                                }
                                onClick={getFirstPage}
                                disabled={isNavControlsEnabled ? false : true}
                            >
                                <BiFirstPage />
                            </button>
                            <p className='epub-page-count'>{pageNumbersText}</p>
                            <button
                                type='button'
                                className={
                                    renditionRef.current?.location?.atEnd
                                        ? 'epub-startend-btn epub-startend-btn--inactive'
                                        : 'epub-startend-btn'
                                }
                                onClick={getLastPage}
                                disabled={isNavControlsEnabled ? false : true}
                            >
                                <BiLastPage />
                            </button>
                        </div>
                        <div className='epub-nav-controls epub-readaloud-cont'>
                            <div>
                                <button
                                    type='button'
                                    className={isAudioEnabled ? 'epub-read-loud-btn epub-read-loud-btn--active' : 'epub-read-loud-btn'}
                                    onClick={enableAudio}
                                    disabled={isAudioBtnEnabled ? false : true}
                                >
                                    {isAudioEnabled ? <FaVolumeUp /> : <FaVolumeMute />}
                                </button>
                            </div>
                        </div>
                    </div>
                )} */}
            </div>
        </>
    );
};
